export default "__VITE_ASSET__76c3df10__"